// extracted by mini-css-extract-plugin
export default {"block-tools":"BlockTools_block-tools__YMkR0","block-tools--mobile":"BlockTools_block-tools--mobile__e2nyz","block-tools__break":"BlockTools_block-tools__break__kumpT"};